import Vue from 'vue';
import Constant from 'BASE/common/lotteryConstant';

/** 修正浮點數溢位 */
Vue.filter('fixFloatingNumber', function (value, decimalPrecision) {
    return parseFloat(value.toFixed(decimalPrecision || Constant.DecimalPrecision));
});

/** 加上千分位符號 */
Vue.filter('currency', function (value) {
    return value.toString().replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function (all, pre, groupOf3Digital) {
        return pre + groupOf3Digital.replace(/\d{3}/g, ',$&');
    });
});